import React from 'react';
import './TokenCard.scss'; // Assuming you have or will create this for styling

// Helper to format currency (can be moved to a common utils file if used elsewhere)
const formatCurrency = (value) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '$0.00'; // Default to $0.00 for invalid inputs
  }
  return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const TokenCard = ({ 
  iconUrl, 
  name, 
  symbol, 
  amount, 
  numericAmount, 
  tokenPriceUSD, 
  isLoadingPrice 
}) => {
  
  const valueUSD = (typeof numericAmount === 'number' && typeof tokenPriceUSD === 'number') 
                   ? numericAmount * tokenPriceUSD 
                   : null;

  return (
    <div className="token-card">
      <div className="token-card-header">
        <img src={iconUrl} alt={`${name} logo`} className="token-card-icon" />
        <div className="token-card-name-symbol">
          <span className="token-card-name">{name}</span>
          <span className="token-card-symbol">({symbol})</span>
        </div>
      </div>
      <div className="token-card-body">
        <div className="token-card-stats-box">
          <p className="token-card-amount">Amount: {amount}</p>
          <div className="token-card-value">
            {isLoadingPrice ? (
              <p>Loading value...</p>
            ) : valueUSD !== null ? (
              <p>Value: {formatCurrency(valueUSD)}</p>
            ) : (
              <p>Value: N/A</p> // Show N/A if price is unavailable after loading
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokenCard; 